import * as z from "zod";

export const turnOnSupportDefaults = {
  name: "turnOnSupportDefaults" as const,
  input: z.object({ enableAI: z.boolean().optional() }),
  output: z.object({}),
};
